"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _reactRouterDom = require("react-router-dom");
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _formGeneratorHelper = require("../../helpers/formGeneratorHelper");
var _formValidations = require("../../helpers/formValidations");
var _passwordScore = _interopRequireDefault(require("../../helpers/passwordScore"));
var _path = _interopRequireDefault(require("../../helpers/path"));
var _commonComponent = require("../../propTypes/commonComponent");
var _APButton = _interopRequireDefault(require("../common/APButton"));
var _APInput = _interopRequireDefault(require("../common/APInput"));
var _APPasswordInput = _interopRequireDefault(require("../common/APPasswordInput/APPasswordInput"));
var _TradingServerComponent = _interopRequireDefault(require("../TradingServer/TradingServerComponent"));
var _config = _interopRequireDefault(require("../../config"));
require("../../styles/components/common/StandaloneForm.css");
require("./SignupFormComponent.css");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('standalone-form');
var signupFormClasses = (0, _cssClassesHelper.getBEMClasses)('signup-form');
var SignupFormComponent = function SignupFormComponent(_ref) {
  var handleSubmit = _ref.handleSubmit,
    errorMsg = _ref.errorMsg,
    clearSignupError = _ref.clearSignupError,
    submitting = _ref.submitting,
    pristine = _ref.pristine,
    isAuthenticated = _ref.isAuthenticated,
    passwordValue = _ref.passwordValue,
    invalid = _ref.invalid,
    done = _ref.done,
    useEmailAsUsername = _ref.useEmailAsUsername,
    additionalFields = _ref.additionalFields,
    termsAndServicesLink = _ref.termsAndServicesLink,
    privacyPolicyLink = _ref.privacyPolicyLink,
    siteName = _ref.siteName,
    formGateway = _ref.formGateway,
    resetGateway = _ref.resetGateway,
    gateway = _ref.gateway;
  var _useTranslation = (0, _reactI18next.useTranslation)('auth'),
    t = _useTranslation.t;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isCustomGateway = _useState2[0],
    setIsCustomGateway = _useState2[1];
  (0, _react.useEffect)(function () {
    if (formGateway === 'CUSTOM' && !isCustomGateway) {
      setIsCustomGateway(true);
      resetGateway();
    }
  }, [formGateway, isCustomGateway]);
  var getPasswordStrength = function getPasswordStrength() {
    var score = (0, _passwordScore["default"])(passwordValue);
    var passwordStrengthValues = {
      0: t('Very Weak'),
      1: t('Weak'),
      2: t('Medium'),
      3: t('Strong'),
      4: t('Very Strong')
    };
    return passwordStrengthValues[score];
  };
  var handleChange = (0, _react.useCallback)(function () {
    if (errorMsg) {
      clearSignupError();
    }
  }, [errorMsg, clearSignupError]);
  if (isAuthenticated) {
    return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Redirect, {
      to: (0, _path["default"])("".concat(_config["default"].Navigation.landingPage))
    });
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(baseClasses('container'), " ").concat(signupFormClasses('form-container'))
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(baseClasses('header'), " ").concat(signupFormClasses('header'))
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(baseClasses('header-text'), " ").concat(signupFormClasses('header-text'))
  }, done ? t('Signup success') : t('{{n}} Sign Up', {
    n: siteName
  }))), done ? /*#__PURE__*/_react["default"].createElement("p", {
    className: "".concat(baseClasses('success'))
  }, t('Thanks for signing up, please check your inbox for a confirmation email')) : /*#__PURE__*/_react["default"].createElement("form", {
    onSubmit: handleSubmit,
    className: "".concat(baseClasses('form'), " ").concat(signupFormClasses('form'))
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: signupFormClasses('wrapper')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: signupFormClasses('container')
  }, !useEmailAsUsername && /*#__PURE__*/_react["default"].createElement(_APInput["default"], {
    type: "text",
    name: "username",
    label: t('Username'),
    validate: [_formValidations.required, _formValidations.noWhiteSpace],
    customClass: signupFormClasses(),
    onChange: handleChange
  }), /*#__PURE__*/_react["default"].createElement(_APInput["default"], {
    type: "text",
    name: "email",
    label: t('Email'),
    validate: [_formValidations.required, _formValidations.email],
    customClass: signupFormClasses(),
    onChange: handleChange
  }), /*#__PURE__*/_react["default"].createElement(_APPasswordInput["default"], {
    type: "password",
    name: "password",
    label: t('Password'),
    validate: [_formValidations.required, _formValidations.validatePassword],
    info: passwordValue && getPasswordStrength(),
    customClass: signupFormClasses(),
    onChange: handleChange
  }), /*#__PURE__*/_react["default"].createElement(_APPasswordInput["default"], {
    type: "password",
    name: "matchingPassword",
    label: t('Retype Password'),
    classes: "signup",
    validate: [_formValidations.required, _formValidations.matchingPassword, _formValidations.validatePassword],
    customClass: signupFormClasses(),
    onChange: handleChange
  }), (0, _formGeneratorHelper.renderFormInputs)(additionalFields, signupFormClasses(), {
    t: t
  }), (!gateway || isCustomGateway) && /*#__PURE__*/_react["default"].createElement(_APInput["default"], {
    type: "text",
    name: "gateway",
    classes: "signup",
    customClass: signupFormClasses(),
    label: t('Gateway'),
    validate: [_formValidations.required]
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: signupFormClasses('gateway-select')
  }, !isCustomGateway && Array.isArray(gateway) && /*#__PURE__*/_react["default"].createElement(_TradingServerComponent["default"], null)), errorMsg && /*#__PURE__*/_react["default"].createElement("p", {
    className: "".concat(baseClasses('error'), " ").concat(signupFormClasses('error'))
  }, errorMsg))), /*#__PURE__*/_react["default"].createElement("div", {
    className: signupFormClasses('footer')
  }, /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
    type: "submit",
    disabled: pristine || submitting || invalid,
    customClass: "".concat(baseClasses(), " ").concat(signupFormClasses()),
    styleName: _commonComponent.styleNames.additive
  }, submitting ? t('Processing...') : t('Sign Up')), /*#__PURE__*/_react["default"].createElement("div", {
    className: signupFormClasses('text')
  }, /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, null, "By Clicking ", /*#__PURE__*/_react["default"].createElement("span", {
    className: signupFormClasses('bold-text')
  }, "Sign up"), " you accept our", ' ', /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: (0, _path["default"])(termsAndServicesLink),
    target: "_blank"
  }, "Terms and Conditions"), ' ', "and", ' ', /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: (0, _path["default"])(privacyPolicyLink),
    target: "_blank"
  }, "Privacy Policy"))))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(baseClasses('footer'), " ").concat(signupFormClasses('links'))
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: (0, _path["default"])('/login'),
    className: signupFormClasses('link')
  }, t('Login')), /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(baseClasses('footer-separator'))
  }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: (0, _path["default"])('/problem-logging-in'),
    className: signupFormClasses('link'),
    disabled: true
  }, t('Forgot Password?'))));
};
SignupFormComponent.defaultProps = {
  handleSubmit: function handleSubmit() {},
  submitting: false
};
SignupFormComponent.propTypes = {
  handleSubmit: _propTypes["default"].func,
  submitting: _propTypes["default"].bool,
  referrer: _propTypes["default"].string,
  search: _propTypes["default"].string,
  shouldRedirect: _propTypes["default"].bool,
  isAuthenticated: _propTypes["default"].bool
};
var _default = exports["default"] = SignupFormComponent;